import { getCustomer } from '@portal/state/shopifyStorefront/getCustomer/getCustomer';
import { useMutation } from '@tanstack/react-query';
import { useStoreValue } from '@portal/state/hooks/useStore';
import { useSession } from './useSession';
import { SessionCustomer } from './schema';

export function useRefreshSession() {
  const store = useStoreValue();
  const [session, setSession] = useSession();

  return useMutation({
    mutationFn: async () => {
      if (session?.accessTokenPayload?.shopify) {
        const { customer: fetchedCustomerData } = await getCustomer(
          session?.accessTokenPayload?.shopify?.accessToken,
          store
        );

        const newSessionCustomer: SessionCustomer = {
          id: parseInt(fetchedCustomerData.id.replace('gid://shopify/Customer/', ''), 10),
          email: fetchedCustomerData.email,
          firstName: fetchedCustomerData.firstName,
          lastName: fetchedCustomerData.lastName,
          phone: fetchedCustomerData.phone,
          tags: fetchedCustomerData.tags,
          metafields: []
        };

        if (fetchedCustomerData.agzWelcomeBoxReceived) {
          newSessionCustomer.metafields = [
            {
              key: fetchedCustomerData.agzWelcomeBoxReceived.key,
              value: fetchedCustomerData.agzWelcomeBoxReceived.value
            }
          ];
        } else {
          newSessionCustomer.metafields = null;
        }

        setSession({
          ...session,
          customer: newSessionCustomer
        });
      }
    }
  });
}
